import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
import { ref, onMounted } from 'vue';
import { defaultContractRevision } from '@/models/contractRevision';
import useJob from '@/composables/useJob';
import useCustomReward from '@/composables/useCustomReward';
import useContractRevision from '@/composables/useContractRevision';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContractRevisionForm',
    props: {
        propRevision: {},
        contract: {}
    },
    emits: ['saved'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { jobs, fetchByIds } = useJob();
        const { customRewards, fetchByCompanyId } = useCustomReward();
        const { upsert } = useContractRevision();
        const revision = ref(defaultContractRevision);
        const hasCustomReward = ref(false);
        const customRewardSelection = computed(() => {
            return customRewards.value.map((customReward) => {
                return {
                    id: customReward.id,
                    text: `${customReward.id}: ${customReward.condition} (${customReward.amount}円)`,
                };
            });
        });
        const toggleCustomReward = () => {
            hasCustomReward.value = !hasCustomReward.value;
            if (!hasCustomReward.value) {
                revision.value.customRewardIds = [];
            }
            else {
                revision.value.successFee = 0;
            }
        };
        const save = async (revision) => {
            revision.contractId = props.contract.id;
            try {
                await upsert(revision);
                window.alert('保存しました。');
                emit('saved');
            }
            catch (e) {
                window.alert('保存に失敗しました。' + e.message);
            }
        };
        onMounted(async () => {
            if (!props.contract) {
                window.alert('契約が見つかりませんでした。');
                return;
            }
            await fetchByCompanyId(props.contract.companyId);
            // idを持つrevision が渡されていたら編集モード
            if (props.propRevision && props.propRevision.id !== 0) {
                revision.value = props.propRevision;
                revision.value.startDate = new Date(revision.value.startDate).toISOString().slice(0, 10); // 編集画面用に変換
                if (revision.value.customRewardIds.length > 0) {
                    hasCustomReward.value = true;
                }
                return;
            }
            // 新規作成モード（案件から数値を取得）
            if (!props.contract.jobId) {
                window.alert('案件IDが見つかりませんでした。' + props.contract.jobId);
                return;
            }
            await fetchByIds([props.contract.jobId]);
            if (jobs.value.length === 0) {
                window.alert('案件が見つかりませんでした。案件ID' + props.contract.jobId);
                return;
            }
            if (jobs.value.length > 1) {
                window.alert('案件が複数見つかりました。案件ID' + props.contract.jobId);
                return;
            }
            // 開始日はとりあえず当日
            revision.value.startDate = new Date().toISOString().slice(0, 10); // 編集画面用に変換
            // 案件情報から初期値を入力
            revision.value.successFee = jobs.value[0].successFee;
            revision.value.serviceFee = jobs.value[0].serviceFee;
            revision.value.guaranteeFee = jobs.value[0].guaranteeFee;
            revision.value.dailyFee = jobs.value[0].dailyFee;
            revision.value.addWorkFee = jobs.value[0].addWorkFee;
            revision.value.trainingFee = jobs.value[0].trainingFee;
            revision.value.hourlyTrainingFee = jobs.value[0].hourlyTrainingFee;
            revision.value.customRewards = jobs.value[0].customRewards;
            revision.value.customRewardIds = jobs.value[0].customRewardIds;
            if (revision.value.customRewardIds.length > 0) {
                hasCustomReward.value = true;
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                            _cache[22] || (_cache[22] = _createElementVNode("h2", null, "契約条件の作成・編集", -1)),
                            _createVNode(_component_v_form, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.startDate,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((revision.value.startDate) = $event)),
                                        label: "契約開始日",
                                        type: "date"
                                    }, null, 8, ["modelValue"]),
                                    (_ctx.contract.jobSections == '新規接客')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (hasCustomReward.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createVNode(_component_v_autocomplete, {
                                                        chips: "",
                                                        clearable: "",
                                                        modelValue: revision.value.customRewardIds,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((revision.value.customRewardIds) = $event)),
                                                        items: customRewardSelection.value,
                                                        "item-title": "text",
                                                        "item-value": "id",
                                                        label: "カスタム報酬",
                                                        multiple: ""
                                                    }, null, 8, ["modelValue", "items"]),
                                                    _createVNode(_component_v_btn, {
                                                        onClick: toggleCustomReward,
                                                        class: "mb-4"
                                                    }, {
                                                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                            _createTextVNode("カスタム報酬を使わない")
                                                        ])),
                                                        _: 1,
                                                        __: [16]
                                                    })
                                                ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: revision.value.successFee,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((revision.value.successFee) = $event)),
                                                        modelModifiers: { number: true },
                                                        label: "成約報酬",
                                                        type: "number",
                                                        suffix: "円"
                                                    }, null, 8, ["modelValue"]),
                                                    _createVNode(_component_v_btn, { onClick: toggleCustomReward }, {
                                                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                            _createTextVNode("カスタム報酬を使う")
                                                        ])),
                                                        _: 1,
                                                        __: [17]
                                                    })
                                                ], 64)),
                                            _createVNode(_component_v_text_field, {
                                                modelValue: revision.value.serviceFee,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((revision.value.serviceFee) = $event)),
                                                modelModifiers: { number: true },
                                                label: "接客報酬",
                                                type: "number",
                                                suffix: "円"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_text_field, {
                                                modelValue: revision.value.guaranteeFee,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((revision.value.guaranteeFee) = $event)),
                                                modelModifiers: { number: true },
                                                label: "来館キャンセル補償",
                                                type: "number",
                                                suffix: "円"
                                            }, null, 8, ["modelValue"])
                                        ], 64))
                                        : (_ctx.contract.jobSections == '施行担当')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (hasCustomReward.value)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createVNode(_component_v_autocomplete, {
                                                            chips: "",
                                                            clearable: "",
                                                            modelValue: revision.value.customRewardIds,
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((revision.value.customRewardIds) = $event)),
                                                            items: customRewardSelection.value,
                                                            "item-title": "text",
                                                            "item-value": "id",
                                                            label: "カスタム報酬",
                                                            multiple: ""
                                                        }, null, 8, ["modelValue", "items"]),
                                                        _createVNode(_component_v_btn, {
                                                            onClick: toggleCustomReward,
                                                            class: "mb-4"
                                                        }, {
                                                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                                _createTextVNode("カスタム報酬を使わない")
                                                            ])),
                                                            _: 1,
                                                            __: [18]
                                                        })
                                                    ], 64))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createVNode(_component_v_text_field, {
                                                            modelValue: revision.value.successFee,
                                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((revision.value.successFee) = $event)),
                                                            modelModifiers: { number: true },
                                                            label: "担当報酬",
                                                            type: "number",
                                                            suffix: "円"
                                                        }, null, 8, ["modelValue"]),
                                                        _createVNode(_component_v_btn, { onClick: toggleCustomReward }, {
                                                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                                _createTextVNode("カスタム報酬を使う")
                                                            ])),
                                                            _: 1,
                                                            __: [19]
                                                        })
                                                    ], 64))
                                            ], 64))
                                            : (_ctx.contract.jobSections == 'イベント・その他')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: revision.value.serviceFee,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((revision.value.serviceFee) = $event)),
                                                        modelModifiers: { number: true },
                                                        label: "接客報酬",
                                                        type: "number",
                                                        suffix: "円"
                                                    }, null, 8, ["modelValue"]),
                                                    _createVNode(_component_v_text_field, {
                                                        modelValue: revision.value.guaranteeFee,
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((revision.value.guaranteeFee) = $event)),
                                                        modelModifiers: { number: true },
                                                        label: "来館キャンセル補償",
                                                        type: "number",
                                                        suffix: "円"
                                                    }, null, 8, ["modelValue"])
                                                ], 64))
                                                : _createCommentVNode("", true),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.dailyFee,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((revision.value.dailyFee) = $event)),
                                        modelModifiers: { number: true },
                                        label: "日給",
                                        type: "number",
                                        suffix: "円"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.addWorkFee,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((revision.value.addWorkFee) = $event)),
                                        modelModifiers: { number: true },
                                        label: "時給",
                                        type: "number",
                                        suffix: "円"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.trainingFee,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((revision.value.trainingFee) = $event)),
                                        modelModifiers: { number: true },
                                        label: "研修報酬（日給）",
                                        type: "number",
                                        suffix: "円"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.hourlyTrainingFee,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((revision.value.hourlyTrainingFee) = $event)),
                                        modelModifiers: { number: true },
                                        label: "研修報酬（時給）",
                                        type: "number",
                                        suffix: "円"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: revision.value.detail,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((revision.value.detail) = $event)),
                                        label: "備考"
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_btn, {
                                onClick: _cache[14] || (_cache[14] = ($event) => (save(revision.value)))
                            }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createTextVNode("保存する")
                                ])),
                                _: 1,
                                __: [20]
                            }),
                            _createVNode(_component_v_btn, {
                                onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.$emit('saved')))
                            }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode("キャンセル")
                                ])),
                                _: 1,
                                __: [21]
                            })
                        ]),
                        _: 1,
                        __: [22]
                    })
                ]),
                _: 1
            }));
        };
    }
});
